export const IMG = 'IMG';
export const MOVIE = 'MOVIE';
export const DOCUMENT = 'DOCUMENT';
export const AUDIO = 'AUDIO';
export const OTHER = 'OTHER';